import {get} from "lodash"
import moment from "moment"

import service from "@irati-tracking/tracker"
import {Poll, PollVote} from "@irati/types"

const tracking = {}

const getWhen = (date) => {
  const d = moment(new Date(date))
  return moment.duration(d.diff(moment())).asDays()
}

tracking.defaultStatusCode = "200"

tracking.startCreatePoll = () => {
  service.trackRecognitionEvent("start_create_poll")
}

tracking.viewInspirations = () => {
  service.trackRecognitionEvent("view_inspirations")
}

tracking.errorsPoll = (response) => {
  const statusCode = get(response, "graphQLErrors[0].apiError.response.status", null)
  const data = {statusCode: `${statusCode}`}
  service.trackRecognitionEvent("poll_error", data)
}

tracking.createPoll = (poll: Poll) => {
  const reward = get(poll, "trophy.alt", null)
  const sharedWith = poll.teams.length ? "Specific Teams" : "Everyone"
  const data = {
    recognition_poll_title: poll.title,
    recognition_poll_criteria: poll.desc,
    recognition_poll_trophy: reward,
    recognition_poll_voting_period: getWhen(poll.endsAt),
    recognition_poll_share_with: sharedWith,
    recognition_poll_company_values: poll.companyValues ? poll.companyValues.join(" ") : "",
    recognition_poll_result_visibility: poll.resultVisibility,
    is_anonymous: poll.allowAnonymousVoting,
    recognition_poll_publish_type: poll.publishType
  }
  service.trackRecognitionEvent("recognition_create_poll", data)
}

tracking.createPollVote = (pollVote: PollVote) => {
  const data = {
    statusCode: tracking.defaultStatusCode,
    is_anonymous: pollVote.isAnonymous
  }
  service.trackRecognitionEvent("vote_poll", data)
}

tracking.errorsPollVote = (response) => {
  const statusCode = get(response, "graphQLErrors[0].apiError.response.status", null)
  const data = {statusCode: `${statusCode}`}
  service.trackRecognitionEvent("vote_poll_error", data)
}

export default tracking
